import React from 'react';
import styled from 'styled-components';
import { theme } from '../../styles/GlobalStyles';

const Wrapper = styled.div`
  text-align: center;
  margin-bottom: 3.5rem;
`;

const Title = styled.h2`
  font-size: clamp(1.8rem, 4vw, 2.6rem);
  font-weight: 700;
  color: ${theme.text};
  position: relative;
  display: inline-block;
  margin-bottom: 0;

  &::after {
    content: "";
    display: block;
    margin: 0.75rem auto 0;
    width: 60px;
    height: 3px;
    border-radius: 2px;
    background: ${theme.gradient};
  }
`;

const SectionTitle = ({ children }) => (
  <Wrapper>
    <Title>{children}</Title>
  </Wrapper>
);

export default SectionTitle;
